import BaseAPI from '@/apis/base/baseApi';

export default class PlatformApi extends BaseAPI {
  apiName = 'Platform';
  constructor() {
    super();
  }
}
